import { makeImmutable } from "./makeImmutable";
export class ApplePayToken {
    constructor(token) {
        this.token = token;
        makeImmutable(this);
    }
}
